import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import NteeDuck from 'app/ducks/ntee-codes';

class NteeLabel extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadAll();
  }

  renderString() {
    const {orgName, minor} = this.props;
    if (!orgName) return '';
    if (!minor) return '';
    const major = minor.parent || minor;
    if (minor.code.startsWith('Z')) return '';

    if (minor.description) {
      return `${orgName} falls under the ${minor.name} category: ${minor.description}`;
    }
    if (major.description) {
      return `${orgName} falls under the ${major.name} category: ${major.description}`;
    }
    if (major) {
      return `${orgName} falls under the ${major.name} category.`;
    }
    if (minor) {
      return `${orgName} falls under the ${minor.name} category.`;
    }

    return '';
  }

  render() {
    return <>{this.renderString()}</>;
  }

}

NteeLabel.propTypes = {
  orgName: PropTypes.string,
  code: PropTypes.string,
};

const stateToProps = (state, ownProps) => ({
  minor: NteeDuck.Slx.nteeObjByCode(state, ownProps.code),
});

const dispatchToProps = (dispatch) => ({
  loadAll: () => dispatch(NteeDuck.Ax.loadAll()),
});

export default connect(stateToProps, dispatchToProps)(NteeLabel);
